export const getSearchValues = (state) => {
  const { search } = state.context;
  return search;
};

export const getSearchValueByKey = (state, key) => {
  const { search } = state.context;
  return search[key];
};
